import { render, staticRenderFns } from "./AnnouncementConfirm.vue?vue&type=template&id=027cf72a&scoped=true"
import script from "./AnnouncementConfirm.vue?vue&type=script&lang=js"
export * from "./AnnouncementConfirm.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementConfirm.vue?vue&type=style&index=0&id=027cf72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027cf72a",
  null
  
)

export default component.exports